/**
 * Controller for AppManager
 */
define('controllers/mysetting/teamaccount/add.member.account.confirm.ctrl',['app'], function (app) {
    app.controller('AddMemberAccountConfirmCtrl', ['$q', '$scope', '$location', '$stateParams', '$state', 'auiDialog', 'OpenOther', 'auiTeamAccountService','langService',
        function ($q, $scope, $location, $stateParams, $state, auiDialog, OpenOther, auiTeamAccountService,langService) {
            var Model = $scope.Model = {};
            if (!$stateParams.teamMemberInfo || !$stateParams.memberResInfo) {
                cancel();
            }
            Model.teamMemberInfo = $stateParams.teamMemberInfo;
            Model.memberResInfo = $stateParams.memberResInfo;
            $scope.cancel = cancel;
            $scope.previousStep = previousStep;
            $scope.submit = submit;
            Model.showMsgLang = true;
            Model.isAddMemberAccountDetail = ($location.url().split('/')[2] =='addMemberAccount') && ($location.url().split('/')[1] =='mysetting') && ($location.url().split('/')[3] =='confirm');

            // 如果有语种，则用语种
            if (Model.teamMemberInfo && Model.teamMemberInfo.memberMsgLang){
                // 获取指定语种对应的条目 选择的lang
                Model.selectedMsgLang = langService.getLangItemByLang(Model.teamMemberInfo.memberMsgLang);
                Model.msgLang = Model.teamMemberInfo.memberMsgLang;
            }
            //取消
            function cancel() {
                $state.go("mysetting.teamAccountInfoList", {reload: true});
            }
            
            //上一步
            function previousStep() {
                $state.go('mysetting.addMemberAccount.rolePermission', {
                    teamMemberInfo: $stateParams.teamMemberInfo,
                    memberResInfo: $stateParams.memberResInfo
                });
            }
            
            //下一步
            function submit() {
                var defer = $q.defer();
                var memberResInfo = angular.copy(Model.memberResInfo);
                var teamMemberInfo = angular.copy(Model.teamMemberInfo);
                if(teamMemberInfo.i18nTelCode){teamMemberInfo.memberLoginName = "00"+teamMemberInfo.i18nTelCode+teamMemberInfo.memberLoginName}
                delete memberResInfo.allianceRoles;
                delete memberResInfo.currentRes;
                delete memberResInfo.currentTeamRes;
                delete memberResInfo.domainserviceRoleIDs;
                delete memberResInfo.productList;
                delete memberResInfo.teamRoles;
                delete teamMemberInfo.i18nTelCode;
                if (memberResInfo.prodConfine == 1 || (memberResInfo.prodIDList && memberResInfo.prodIDList.length == 0)) delete memberResInfo.prodIDList;
                if(!memberResInfo.prodIDList && memberResInfo.prodConfine != 3){
                    memberResInfo.prodConfine = 1
                }
                if (Model.teamMemberInfo.fakeMemberID) {
                    memberResInfo.fakeMemberID = Model.teamMemberInfo.fakeMemberID;
                    OpenOther.updateTeamMemberRes({
                        req: {
                            teamMemberInfo: teamMemberInfo,
                            memberResInfo: memberResInfo
                        }
                    }).then(function (data) {
                        if (data && data.teamMemberInfo && (data.teamMemberInfo.memberState == 3 || data.teamMemberInfo.memberState == 4)) {
                            auiDialog.success("修改成功", function () {
                                defer.resolve();
                                cancel();
                            });
                        } else {
                            if (data && data.teamMemberInfo && data.teamMemberInfo.memberState == 1) {
                                auiDialog.confirm("修改成功", "已修改成功，该成员已在邀请中，是否重新发送邀请？", function () {
                                    reInvitingMember(data.teamMemberInfo.fakeMemberID,defer);
                                }, function () {
                                    cancel();
                                    defer.reject();
                                });
                            } else {
                                auiDialog.confirm("修改成功", "已修改成功，该成员邀请已过期，是否重新发送邀请？", function () {
                                    reInvitingMember(data.teamMemberInfo.fakeMemberID,defer);
                                }, function () {
                                    cancel();
                                    defer.reject();
                                });
                            }
                            
                        }
                    }).catch(function () {
                        defer.resolve();
                    });
                } else {
                    OpenOther.addTeamMemberRes({
                        req: {
                            teamMemberInfo: teamMemberInfo,
                            memberResInfo: memberResInfo
                        }
                    }).then(function (data) {
                        if (data && data.userID) {
                            auiDialog.success("邀请成功","邀请邮件已成功发送至被邀请成员邮箱", function () {
                                defer.resolve();
                                cancel();
                            });
                        }
                    }).catch(function () {
                        defer.resolve();
                    });
                }
                return defer.promise;
            }


            function reInvitingMember(fakeMemberID,defer) {
                auiTeamAccountService.reInviting(fakeMemberID).then(function (data) {
                    auiDialog.success("重新邀请成功","邀请邮件已成功重新发送至被邀请成员邮箱", function () {
                        defer.resolve();
                        cancel();
                    });
                }).catch(function () {
                    defer.resolve();
                });
            }
            
        }]);
});
